import { NAME} from './constants';

export const uiLabels = state => state[NAME].labels.labels;
export const curLanguage = state => state[NAME].appsettings.lang;
